import React from "react";

const MESSAGE = "Cette commande a changé depuis votre saisie. Vos modifications sont conservées. Fermez puis rouvrez la saisie pour reprendre les données enregistrées.";

export function orderEditHasConflict(original, orders) {
  if (!original?.updated_at) return false;
  const current = orders.find((order) => order.order_id === original.order_id);
  return Boolean(current && current.updated_at !== original.updated_at);
}

export default function useDataManagerEditConflicts({ original, execution, orders, pending, showToast }) {
  const notified = React.useRef(null);
  const conflict = orderEditHasConflict(original, orders);
  React.useEffect(() => {
    if (!original || !conflict) { notified.current = null; return; }
    if (pending || notified.current === original) return;
    notified.current = original;
    showToast({ title: "Commande actualisée", message: MESSAGE, type: "info", duration: 8000 });
  }, [original, conflict, pending, showToast]);
  return orderEditHasConflict(execution, orders) && !pending ? MESSAGE : "";
}
